import type { JSX } from "react";
import type { FluidPayApi } from "./api-interface";
import { FluidPayApiProvider } from "./context";

export interface FluidPayCoreProviderProps {
  api: FluidPayApi;
  children: React.ReactNode;
}

export function FluidPayCoreProvider({
  api,
  children,
}: FluidPayCoreProviderProps): JSX.Element {
  return <FluidPayApiProvider value={api}>{children}</FluidPayApiProvider>;
}
